import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Arquivo from '../../../../components/auth/atos/listar/form_arquivo'


function ArquivoAtosScreen() {

    return (
        <Fragment>
            <Head titulo="Substituindo Arquivo - Atos Oficiais do Governo" />
            <HeaderLogged />
            <Container>
               <Arquivo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ArquivoAtosScreen;